import React from 'react';
import SectionHead from '../../../ui-components/SectionHead';
import TaskGroup from './components/task-group/TaskGroup'

import './group-task-list.scss'

const GroupTaskList = () => {
    const mockGrops = [
        {
            type: "Remote",
            items: [
                {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
            ]
        },
        {
            type: "Deactivated",
            items: [
                {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
            ]
        },
        {
            type: "Past",
            items: [
                {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
            ]
        },
        {
            type: "Marked",
            items: [
                {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
            ]
        },
        {
            type: "No show",
            items: [
                {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
            ]
        },
        {
            type: "Availability",
            items: [
                {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
            ]
        },
        {
            type: "Space",
            items: [
                {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
            ]
        },
        {
            type: "Initial Report",
            items: [
                {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
            ]
        }
    ]

    return (
        <div className='group-task-list'>
            <SectionHead head={"Dashboard"}/>
            
            <div className='group-list'>
                {
                    mockGrops.map((group, i) => <TaskGroup type={group.type} items={group.items} key={i}/>)
                }
            </div>
        </div>
    );
};

export default GroupTaskList;